import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	NgModule,
	Output,
} from '@angular/core';

import { ClientScreenDirectives } from '~app-client/core/directives';
import { ClientScreen } from '~app-client/core/services';

@Component({
	standalone: false,

	selector: 'info-modal-cdk',
	templateUrl: './modal-cdk.component.html',
	styleUrls: ['./modal-cdk.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalCdkComponent {
	@HostBinding('class.closing')
	@Input()
	public closing = false;

	@Input()
	public typeModal: ClientScreen = ClientScreen.MOBILE;

	@HostBinding('style.--width-modal')
	get setWidthModal(): string {
		if (this.typeModal === ClientScreen.MOBILE) {
			return 'min(calc(100% - 32px), 328px)';
		} else {
			return '800px';
		}
	}

	@HostBinding('style.--height-modal')
	get setHeightModal(): string {
		if (this.typeModal === ClientScreen.MOBILE) {
			return 'min(calc(100% - 64px), 524px);';
		} else {
			return '760px';
		}
	}

	@Output('outsideClick')
	public outsideClick$$ = new EventEmitter<Event>();

	@HostListener('click', ['$event'])
	public onOutsideClick(event: Event): void {
		this.outsideClick$$.emit(event);
	}
}

@NgModule({
	declarations: [InfoModalCdkComponent],
	imports: [CommonModule, ClientScreenDirectives],
	exports: [InfoModalCdkComponent],
})
export class InfoModalCdkModule {}
